import React, { createContext, useContext, useMemo, useState } from 'react';
import translations from './translations';

const I18nContext = createContext({
  locale: 'en',
  t: (key) => key,
  setLocale: () => {},
  supportedLocales: ['en', 'ar', 'de', 'hi'],
});

export const I18nProvider = ({ children }) => {
  const [locale, setLocale] = useState('en');

  const t = useMemo(
    () => (key, params = {}) => {
      const pattern = translations[locale]?.[key] ?? key;
      return Object.entries(params).reduce(
        (text, [paramKey, paramValue]) => text.replace(`{${paramKey}}`, paramValue),
        pattern,
      );
    },
    [locale],
  );

  const supportedLocales = useMemo(() => Object.keys(translations), []);

  return (
    <I18nContext.Provider value={{ locale, t, setLocale, supportedLocales }}>
      {children}
    </I18nContext.Provider>
  );
};

export const useI18n = () => useContext(I18nContext);
